import { AdminPanelHeader, SideBar } from 'components';
import useApiManager from 'networking/ApiManager';
import React, { useEffect, useMemo, useRef } from 'react';
import { useState } from 'react';
import { unstable_HistoryRouter, useLocation, useNavigate, useParams } from 'react-router-dom';
import 'whealth-core-web/components/prescription.scss';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';
import { useGetCockpitDataQuery } from 'redux/cockpitSlice';
import { profileImage } from 'whealth-core-web/components/Helper';
import { pdf } from '@react-pdf/renderer';
import OPDReportPDF from 'whealth-core-web/components/PrescriptionPdf/Content';
import {
  Select2DropDown,
  AddPrescriptionFormDynamic,
  AddPrescriptionPMSForm,
  AddPrescriptionRecord,
  CommonAlert,
  Loader,
  CoreInputBox,
  CoreButton,
} from 'whealth-core-web/components';
import InformationViewCard from './InformationViewCard';
import { Modal, Button, ButtonToolbar, Placeholder } from 'rsuite';
import { EllipsisVertical, Menu, TriangleAlert, UploadCloud, Music, Play, Pause, Trash2 } from 'lucide-react';
import { set } from 'rsuite/esm/utils/dateUtils';

function AddPrescription() {
  const location = useLocation();
  const duplicateId = location?.state?.id;
  const navigation = useNavigate();
  const ApiClient = useApiManager();
  const { id, pid } = useParams();
  let userData = useGetLoginUserDataQuery()?.data?.data || {};
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [openNoPrescriptionModal, setOpenNoPrescriptionModal] = useState(false);
  const [dynamicPerscriptionData, setDynamicPerscriptionData] = useState('');
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [errors, setErrors] = useState({ prescription_medicines: [] });
  const [alertType, setAlertType] = useState('alert-success');
  const [prescriptionData, setPrescriptionData] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [departmentName, setDepartmentName] = useState('');
  const [departmentList, setDepartmentList] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [defaultDepartmentData, setDefaultDepartmentData] = useState([]);

  const [mandatoryMedicine, setMandatoryMedicine] = useState(false);
  const [departmentApi, setDepartmentApi] = useState(false);
  const [pdfModal, setPdfModule] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [printId, setPrintId] = useState('');
  const [clinic , setClinic] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState('');
  const [isPublish, setIsPublish] = useState(false);
  const [pafData,setPafdata] = useState(0)
  const [paf,setPaf] = useState(0)
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const uploadInputRef = useRef(null);
  const uploadAudioRef = useRef(null);

  const getCockpitData = useGetCockpitDataQuery();

  let configData = getCockpitData?.data?.data?.business_config;

  useEffect(() => {
    configData?.map((item) => {
      if (item.key == 'mandatory_medicine' && item.isActive) setMandatoryMedicine(true);
    });
  }, configData);

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message = 'Are you sure you want to leave? All provided data will be lost.';
    e.returnValue = message;
    return message;
  };

  useEffect(() => {
    let isEql = dynamicPerscriptionData?.department?.id == userData?.department?.id;
    if (dynamicPerscriptionData?.department?.id) {
      setSelectedDepartment(dynamicPerscriptionData?.department?.id);
    } else if (userData?.department?.id) {
      setSelectedDepartment(userData?.department?.id);
      setSelectedDoctor(userData?.id);
    }

    if(dynamicPerscriptionData?.clinic?.id){
      setSelectedClinic(dynamicPerscriptionData?.clinic?.id)
    }
    
    if(userData?.role == 'doctor'){
      setClinic(userData?.locations)
      if(!dynamicPerscriptionData?.clinic?.id){
        ApiClient.currentClinic(userData?.id)
          .then((res) => {
            if(res?.data?.current_clinic?.id){
              setSelectedClinic(res.data.current_clinic.id);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }

    if (dynamicPerscriptionData?.isUpdate == true && dynamicPerscriptionData.department?.uuid) {
      setSelectedDoctor(dynamicPerscriptionData?.doctor?.id);
      getPrescriptionSchema(dynamicPerscriptionData.department?.uuid, dynamicPerscriptionData);
    } else if (!pid && duplicateId) {
      if (!isEql && dynamicPerscriptionData.department && userData?.department?.uuid) {
        handleDefaultDepartment();
      }
    } else {
      if (userData?.department?.uuid) {
        handleDefaultDepartment();
      }
    }
  }, [userData, dynamicPerscriptionData?.department?.id]);

  // useEffect(() => {
  //   if (!pid && !duplicateId && userData?.department?.uuid) {
  //     getDepartment();
  //   }
  // }, [userData]);
  useEffect(() => {
    getPrescriptionDepartment();
    getAllDoctor();
  }, []);

  const handleDefaultDepartment = (department_id) => {
    if (Object.keys(defaultDepartmentData).length) {
      getPrescriptionSchema(department_id, defaultDepartmentData);
    } else if (!location?.state?.id) {
      getDefaultPrescriptionData(department_id);
    }
  };

  const handleDoctorDepartment = (department_id) => {
    console.log('location',location)
    if (Object.keys(defaultDepartmentData).length) {
      getPrescriptionSchema(department_id, defaultDepartmentData);
    } else if (!location?.state?.id) {
      getDefaultPrescriptionData(department_id);
    }
  };

  const handleLocations = (doctor_id) => {
    console.log(doctor_id)
    let params = {}
    ApiClient.getLocationByAdmin(doctor_id, params)
    .then((res) => {
      console.log(res.data)
      setIsLoading(false);
      setClinic(res.data);
    })
    .catch((err) => {
      setIsLoading(false);
    });


  }

  const getDefaultPrescriptionData = (department_id) => {
    setIsLoading(true);
    ApiClient.getPublishedPrescriptionData(id)
      .then((res) => {
        setIsLoading(false);
        setDefaultDepartmentData(res.data);
        getPrescriptionSchema(department_id, res.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const getPrescriptionDepartment = () => {
    ApiClient.prescriptionDepartments(id)
      .then((res) => {
        setDepartmentList(res.data);
      })
      .catch((err) => {});
  };

  const getAllDoctor = () => {
    ApiClient.getAllDoctor(id)
      .then((res) => {
        setDoctorList(res.data);
      })
      .catch((err) => {});
  };

  // const getDepartment = () => {
  //   ApiClient.searchDepartments()
  //     .then((res) => {
  //       setDepartmentList(res.data);
  //     })
  //     .catch((err) => {});
  // };

  useEffect(() => {
    if (pid) {
      getPrescriptionData();
    } else if (duplicateId) {
      getPrescriptionData(duplicateId);
    }
  }, [pid, duplicateId]);

  const filterDefaultData = (data, key, getIndex) => {
    let newData = {};
    let itemIndex;

    if (data) {
      data?.map((item, index) => {
        if (item.name == key) {
          newData = item;
          itemIndex = index;
        }
      });
    }

    if (getIndex) {
      return itemIndex;
    } else {
      return newData;
    }
  };

  const getPrescriptionSchema = (departmentID, data) => {
    let filterData = filterDefaultData(data.data, 'diagnosis');
    let ans = filterData?.answer;

    let params = { uuid: departmentID || userData?.department?.uuid };
    if (data?.isUpdate == true) {
      var pids = null;
    } else {
      var pids = pid || duplicateId;
    }
    setIsLoading(true);
    ApiClient.prescriptionSchema(id, pids, params)
      .then((res) => {
        let prescriptionSchemaData = res.data;
        let filterDataIndex = filterDefaultData(prescriptionSchemaData.prescription_schema, 'primary_diagnosis', true);
        if (
          ans &&
          prescriptionSchemaData?.prescription_schema &&
          prescriptionSchemaData.prescription_schema[filterDataIndex] &&
          !prescriptionSchemaData.prescription_schema[filterDataIndex].answer
        ) {
          prescriptionSchemaData.prescription_schema[filterDataIndex].answer = ans;
        }

        if (prescriptionSchemaData?.enable_medicine) {
          if (mandatoryMedicine) {
            prescriptionSchemaData.prescription_medicines = [
              {
                dosage: '000',
                medicine_id: '',
                duration: 0,
                frequency: '',
                note: '',
                medicine: { name: '' },
              },
            ];
          } else {
            prescriptionSchemaData.prescription_medicines = [];
          }
        }
        setDynamicPerscriptionData(prescriptionSchemaData);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const getPrescriptionData = (prescription_id = pid) => {
    setIsLoading(true);
    ApiClient.prescriptionData(id, prescription_id)
      .then((res) => {
        setIsLoading(false);
        setPrescriptionData(res.data);
        if (!!Object.entries(res.data?.data).length) {
          let tmpData = res.data;
          tmpData.prescription_schema = res.data.data;
          tmpData.isUpdate = true;
          let checkInDateIndex = tmpData.prescription_schema.findIndex((item2) => item2.name === 'next_followup_date');
          if (checkInDateIndex != -1 && !pid) {
            tmpData.prescription_schema[checkInDateIndex].answer = '';
          }
          console.log('******tmpData', tmpData);
          setDynamicPerscriptionData(tmpData);
        } else {
          setPrescriptionData(res.data);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const updatePrescription = (data) => {
    setIsLoading(true);
    if (selectedDoctor) {
      data.department = selectedDepartment;
      data.doctor = selectedDoctor;
    } else if (dynamicPerscriptionData?.department?.id) {
      data.department = dynamicPerscriptionData?.department?.id;
    }
    ApiClient.updatePrescription(id, pid, data)
      .then((res) => {
        setIsLoading(false);
        setAlertType('alert-success');
        setIsShowAlert('Prescription updated successfully ');
        if (res?.data?.data?.id) {
          if(data.sync){

          }else{
            openModalPdf(res?.data?.data?.id);
          }
          
        }
        // console.log(res?.data?.data?.id)
        // setTimeout(() => {
        //   navigation(`/patient/${id}/dashboard`);
        // }, 2500);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrors(err.response.data.errors);
        if (err.response.data?.errors?.non_field_errors || err.response.data?.errors?.details) {
          setAlertType('alert-danger');
          setIsShowAlert(Object.values(err.response.data?.errors?.non_field_errors || err.response.data.errors)[0]);
        }
      });
  };

  const prescriptionCreate = (data, noPrescription = false,recording = false) => {
    setIsLoading(true);
    console.log("audio data",recording)
    if (selectedDepartment) {
      data.clinic = selectedClinic
      data.department = selectedDepartment;
      data.doctor = selectedDoctor;
    } else if (dynamicPerscriptionData?.department?.id) {
      data.clinic = selectedClinic
      data.department = dynamicPerscriptionData.department.id;
    }
    if (noPrescription) {
      data.no_prescription = true;
    }
    ApiClient.prescriptionCreate(data, id)
      .then((res) => {
        setIsLoading(false);
        if(res?.data?.is_issue){
          setAlertType('alert-danger');
          setIsShowAlert(res?.data?.message);
        }else{
          setAlertType('alert-success');
          setIsShowAlert('Prescription created successfully ');
        }
        
        if (res?.data?.data?.id) {
          if (noPrescription) {
            setOpenNoPrescriptionModal(false);
            setTimeout(() => {
              navigation(`/patient/${id}/dashboard`);
            }, 1500);
          } else {
            if(recording){
              redirectEditRecording(res?.data?.data?.id);
            }else{
              openModalPdf(res?.data?.data?.id);
            }
            
          }
        }
        // setTimeout(() => {
        //   navigation(`/patient/${id}/dashboard`);
        // }, 2500);
      })
      .catch((err) => {
        console.warn('er', err);
        setAlertType('alert-danger');
        if (err?.data?.message){
          setIsShowAlert(err?.data?.message);
        }else{
          setIsShowAlert(err.message);
        }
        
        setIsLoading(false);
        setErrors(err.response.data.errors);
        if (err.response.data?.errors?.non_field_errors || err.response.data?.errors?.details) {
          setAlertType('alert-danger');
          setIsShowAlert(Object.values(err.response.data?.errors?.non_field_errors || err.response.data.errors)[0]);
        }
      });
  };
  const closeModalPdf = (item) => {
    setPdfModule(!pdfModal);
  };

  // ----------------------------
  // Upload Audio
  // ----------------------------
  const openUploadModal = () => {
    if (!selectedClinic) {
      alert('Please select Clinic');
      return;
    }
    if (!selectedDoctor) {
      alert('Please select Doctor');
      return;
    }
    setUploadedFile(null);
    setUploadedFileUrl(null);
    setUploadModalOpen(true);
  };

  const closeUploadModal = () => {
    setUploadModalOpen(false);
    setUploadedFile(null);
    setUploadedFileUrl(null);
    setIsDragOver(false);
    setIsAudioPlaying(false);
  };

  const toggleAudioPlayback = (e) => {
    e.stopPropagation();
    if (!uploadAudioRef.current) return;
    if (isAudioPlaying) {
      uploadAudioRef.current.pause();
    } else {
      uploadAudioRef.current.play();
    }
  };

  const isAudioFile = (file) => file && (file.type.startsWith('audio/') || /\.(mp3|wav|webm|m4a|ogg|aac|flac)$/i.test(file.name || ''));

  const setAudioFile = (file) => {
    if (!file) return;
    if (!isAudioFile(file)) {
      alert('Please select a valid audio file.');
      return;
    }
    setUploadedFile(file);
    setUploadedFileUrl(URL.createObjectURL(file));
    setIsAudioPlaying(false);
  };

  const handleUploadFileChange = (e) => {
    setAudioFile(e.target.files?.[0]);
  };

  const handleUploadDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    setAudioFile(e.dataTransfer.files?.[0]);
  };

  const removeUploadedFile = (e) => {
    e.stopPropagation();
    if (uploadAudioRef.current) uploadAudioRef.current.pause();
    setUploadedFile(null);
    setUploadedFileUrl(null);
    setIsAudioPlaying(false);
    if (uploadInputRef.current) uploadInputRef.current.value = '';
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const submitUploadedAudio = () => {
    if (!uploadedFile) {
      alert('Please select an audio file to upload.');
      return;
    }

    let prescription_data = {
      is_new: 1,
      recording: 1,
      doctor: selectedDoctor,
      department: selectedDepartment,
      clinic: selectedClinic,
    };
    prescription_data.diagnosis_data = [];
    prescription_data.def_diagnosis_data = [];
    prescription_data.vital_data = { bp: '', pulse: '', temperature: '', respiration: '', height: '', weight: '', bmi: '' };
    prescription_data.pms_data = {
      vas_score: '',
      is_final: false,
      health_condition: [],
      previous_investigation_report: '',
      principal_complaints: '',
      pain_treatment_history: '',
      final_diagnosis: 0,
      next_checkin_date: null,
      drug_allergies: [],
      mdt_consults_advised: '',
      internal_note: '',
    };
    prescription_data.health_condition = [];
    prescription_data.drug_allergies = [];
    prescription_data.medication_data = [];
    prescription_data.investigation_data = [];
    prescription_data.treatment_other_data = [];
    prescription_data.treatment_procedure_data = [];
    prescription_data.imaging_data = [];
    prescription_data.red_alert = [];
    prescription_data.treatment_medication = [];

    if (dynamicPerscriptionData?.prescription_schema) {
      prescription_data.data = dynamicPerscriptionData.prescription_schema;
    }

    if (dynamicPerscriptionData?.enable_medicine) {
      prescription_data.prescription_medicines = dynamicPerscriptionData.prescription_medicines;
    }

    const formData = new FormData();
    formData.append('recording', uploadedFile, uploadedFile.name || 'uploaded_recording.webm');
    formData.append('prescription_data', JSON.stringify(prescription_data));

    (pid ? updatePrescription : prescriptionCreate)(formData, false, true);

    closeUploadModal();
  };

 useEffect(() => {
  if(selectedDoctor){
    setIsLoading(true);
    ApiClient.pafData(id, 1,selectedDoctor)
      .then((res) => {
        setIsLoading(false);
        if(res?.data?.id){
          setPafdata(res?.data?.id)
          setPaf(res?.data)
        }else{
          setPafdata(0)
        }
      })
      .catch((err) => {
        setPafdata(0)
        setIsLoading(false);
        console.log(err);
      });
  }
  
  }, [selectedDoctor]);

  const editPaf = (pafData,id) => {
    window.open(`/patient/${id}/paf/${pafData}?view=1`, '_blank');
  };

  const openModalPdf = async (pres_id) => {
    setPrintId(pres_id);
    if (!pdfModal) {
      setIsLoading(true);
      try {
        const res = await ApiClient.prescriptionPdfDownload(id, pres_id);
        console.log(res);
        let blobURL= ''
        // Generate PDF blob
        if(res.data){
          const blob = await pdf(<OPDReportPDF data={res.data} />).toBlob();
          blobURL = URL.createObjectURL(blob);
        }
        
  
        setPdfUrl(blobURL);
        setPdfModule(!pdfModal);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        console.error(err);
      }
    }
  };

  const redirectEditRecording = async (pres_id) => {
    setTimeout(() => {
      navigation(`/patient/${id}/prescriptions/${pres_id}/edit`);
    }, 1000);
  }

  // const openModalPdf = (pres_id) => {
  //   setPrintId(pres_id);
  //   console.log(pdfModal);
  //   if (!pdfModal) {
  //     setIsLoading(true);
  //     ApiClient.prescriptionPdfDownload(id, pres_id)
  //       .then((res) => {
  //         // console.log(res)
  //         setIsLoading(false);
  //         var blob = new Blob([res.data], { type: 'application/pdf' });
  //         var blobURL = URL.createObjectURL(blob);
  //         setPdfUrl(blobURL);
  //         setPdfModule(!pdfModal);
  //         setIsLoading(false);
  //       })
  //       .catch((err) => {
  //         setIsLoading(false);
  //         console.log(err);
  //       });
  //   }
  // };

  const handlePublishAndPrint = () => {
    const windowConfirm = window.confirm(`Are you sure, you want to publish prescription?`);
    if (windowConfirm) {
      setIsLoading(true);
      setIsPublish(true)
      ApiClient.statusPublish(id, printId)
        .then((res) => {
          
          setAlertType('alert-success');
          setIsShowAlert('Prescription Published successfully ');
          
          let iframe = document.createElement('iframe'); //load content in an iframe to print later
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = pdfUrl;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
          // const link = document.createElement('a');
          // link.href = pdfUrl;
          // link.download = 'prescription_'+id+'.pdf'; // set your desired filename
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
          // setTimeout(() => {
          //   navigation(`/patient/${id}/dashboard`);
          // }, 1500);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
      setPdfModule(false);
    }
  };

  let userDetails = localStorage.getItem('userDetails');
  userDetails = JSON.parse(userDetails);

  const showTree = [
    { iconClass: 'person_outline', title: 'Patient', link: '/patient' },
    {
      icon: profileImage(userDetails?.gender, userDetails?.image),
      title: userDetails?.name,
      link: `/patient/${id}/dashboard`,
    },
    { title: (pid ? 'Update' : 'New') + ' Prescription', link: '' },
  ];

  const profileCardData = {
    heading: 'Profile Details',
    data: [
      {
        label: 'Name',
        value: 'Priyanshu Singh',
      },
      {
        label: 'Age',
        value: '24',
      },
      {
        label: 'Gender',
        value: 'Male',
      },
      {
        label: 'Patient ID',
        value: '13875',
      },
    ],
  };

  const OPDCardData = {
    heading: 'OPD Details',
    data: [
      {
        label: 'Date of Visit',
        value: '24 March 2025',
      },
      {
        label: 'Time of Visit',
        value: '02:00 PM',
      },
      {
        label: 'OPD Type',
        value: 'In Hospital',
      },
      {
        label: 'OPD Mode',
        value: 'In Hospital',
      },
      {
        label: 'Dr. Name',
        value: 'Dr. Ketan Malkhan',
      },
      {
        label: 'Degree',
        value: 'MBBS',
      },
      {
        label: 'Reg. Number',
        value: '13875-12C4 / A142',
      },
    ],
  };

  const renderDoctorDropdown = () => {
    return (
      <div className='daypart-input behaviourpart_box w-100'>
        <Select2DropDown
          value={selectedDoctor}
          data={doctorList}
          labelKey='full_name'
          label={'Doctor'}
          placeholder={'Select Doctor'}
          valueKey='id'
          getObjData
          retuired
          onSelect={(_, selectedValue) => {
            setSelectedDoctor(selectedValue?.id || '');
            setSelectedDepartment(selectedValue?.department_id || '');
            setDepartmentName(selectedValue?.department_name || '');
            if (selectedValue?.department_uuid) {
              handleDoctorDepartment(selectedValue?.department_uuid);
              handleLocations(selectedValue?.id);
            }
            setShowDialog(true);
          }}
          showMSG={''}
        />
      </div>
    );
  };

  const renderDepartmentDropdown = () => {
    return (
      <div className='daypart-input behaviourpart_box w-100'>
        <CoreInputBox
          disabled={true}
          // showMSG={medicineError?.name}
          placeholder='Department'
          value={departmentName || ''}
          label='Department Name'
          maxLength={255}
          msgStyle={{ color: 'red' }}
          retuired
        />

        {/* <Select2DropDown
          value={selectedDepartment}
          data={departmentList}
          labelKey='name'
          label={'Department'}
          placeholder={'Department'}
          valueKey='id'
          getObjData
          retuired
          onSelect={(_, selectedValue) => {
            setSelectedDepartment(selectedValue?.id || '');
            if (selectedValue?.uuid) {
              handleDefaultDepartment(selectedValue?.uuid);
            }
            setShowDialog(true);
          }}
          showMSG={''}
        /> */}
      </div>
    );
  };

  const createNoPrescription = () => {
    prescriptionCreate({ is_new: true }, true);
  };

  const showPatient = () => {
    const renderPage = () => {
      if (dynamicPerscriptionData) {
        if (selectedDepartment == 1) {
          return (
            <>
            {console.log("duplicateId", pid,prescriptionData,'dynamicPerscriptionData',dynamicPerscriptionData)}
            {pid ?
              <>
              {prescriptionData ?
                <>
                  {console.log("prescriptionData = ",prescriptionData)}
                  <AddPrescriptionPMSForm
                    dynamicPerscriptionData={prescriptionData}
                    setDynamicPerscriptionData={setDynamicPerscriptionData}
                    setErrors={setErrors}
                    selectedDepartment={selectedDepartment}
                    selectedDoctor={selectedDoctor}
                    selectedClinic={selectedClinic}
                    errors={errors}
                    onClick={pid ? updatePrescription : prescriptionCreate}
                    setAlertType={setAlertType}
                    setIsShowAlert={setIsShowAlert}
                    isShowAlert={isShowAlert}
                    alertType={alertType}
                    userRole={userData?.role}
                    isNivanCareTeam
                    paf={paf}
                    pafData={pafData}
                    pid={pid}
                    isPublish={isPublish}
                  /> 
                </>
                :null
              }
              </>
            : 
              <>
                
              <AddPrescriptionPMSForm
                dynamicPerscriptionData={dynamicPerscriptionData}
                setDynamicPerscriptionData={setDynamicPerscriptionData}
                setErrors={setErrors}
                selectedDepartment={selectedDepartment}
                selectedDoctor={selectedDoctor}
                selectedClinic={selectedClinic}
                errors={errors}
                onClick={pid ? updatePrescription : prescriptionCreate}
                setAlertType={setAlertType}
                setIsShowAlert={setIsShowAlert}
                isShowAlert={isShowAlert}
                alertType={alertType}
                userRole={userData?.role}
                isNivanCareTeam
                paf={paf}
                pafData={pafData}
                pid={pid}
                isPublish={isPublish}
              /> 
              
               <AddPrescriptionRecord
                  dynamicPerscriptionData={dynamicPerscriptionData}
                  setDynamicPerscriptionData={setDynamicPerscriptionData}
                  setErrors={setErrors}
                  selectedDepartment={selectedDepartment}
                  selectedDoctor={selectedDoctor}
                  selectedClinic={selectedClinic}
                  errors={errors}
                  onClick={pid ? updatePrescription : prescriptionCreate}
                  setAlertType={setAlertType}
                  setIsShowAlert={setIsShowAlert}
                  isShowAlert={isShowAlert}
                  alertType={alertType}
                  userRole={userData?.role}
                  isNivanCareTeam
                  patientName={userDetails?.name}
              />
              
              </>
            
            }
              
              
            </>
          );
        } else {
          return (
            <AddPrescriptionFormDynamic
              dynamicPerscriptionData={dynamicPerscriptionData}
              setDynamicPerscriptionData={setDynamicPerscriptionData}
              setErrors={setErrors}
              selectedDepartment={selectedDepartment}
              selectedClinic={selectedClinic}
              errors={errors}
              onClick={pid ? updatePrescription : prescriptionCreate}
              setAlertType={setAlertType}
              setIsShowAlert={setIsShowAlert}
              isShowAlert={isShowAlert}
              alertType={alertType}
              isNivanCareTeam
            />
          );
        }
      }
    };
    return (
      <>
        <div className='teamHeader stickyHeader'>
          <div className='headerFiles'>
            <AdminPanelHeader iconTitle='person_outline' showTree={showTree} title='Patient' />
          </div>
          <div className='addnewform-part'>{pid ? 'Update' : 'Add New'} Prescription</div>
          <div className='hrLine' />
        </div>
        <div className='px-4 wrapperContent'>
          {isShowAlert && alertType == 'alert-success' && (
            <div className='mt-5'>
              <CommonAlert isShowAlert={isShowAlert} alertType={alertType} setIsShowAlert={setIsShowAlert} />
            </div>
          )}
          {isShowAlert && alertType == 'alert-danger' && (
            <div className='mt-5'>
              <CommonAlert isShowAlert={isShowAlert} alertType={alertType} setIsShowAlert={setIsShowAlert} />
            </div>
          )}
          {userData?.role != 'doctor' && !pid && !duplicateId && doctorList?.length ? (
            <div className='card mt-3 d-flex flex-row gap-4 justify-content-between' style={{ 'margin-left': '50px', 'margin-right': '200px' }}>
              <div className='card-body'>{renderDoctorDropdown()}</div>
              <div className='card-body'>
                <div className='daypart-input behaviourpart_box w-100'>
                    <Select2DropDown
                        value={selectedClinic}
                        data={clinic}
                        labelKey='name'
                        label={'Clinic'}
                        placeholder={'Clinic'}
                        valueKey='id'
                        getObjData
                        retuired
                        onSelect={(_, selectedValue) => {
                          setSelectedClinic(selectedValue?.id || '');
                        }}
                        showMSG={''}
                      />
                </div>
              </div>
              <div className='card-body'>{renderDepartmentDropdown()}</div>
            </div>
          ) : 
          (!pid && !duplicateId && doctorList?.length ) ? 
            <div className='card mt-3 d-flex flex-row gap-4 justify-content-between' style={{ 'margin-left': '50px', 'margin-right': '200px' }}>
              <div className='card-body'>
                    <div className='daypart-input behaviourpart_box w-100'>
                        <Select2DropDown
                            value={selectedClinic}
                            data={clinic}
                            labelKey='name'
                            label={'Clinic'}
                            placeholder={'Clinic'}
                            valueKey='id'
                            getObjData
                            retuired
                            onSelect={(_, selectedValue) => {
                              setSelectedClinic(selectedValue?.id || '');
                            }}
                            showMSG={''}
                          />
                    </div>
                  </div>
              </div>
              : 
              <div className='card mt-3 d-flex flex-row gap-4 justify-content-between' style={{ 'margin-left': '50px', 'margin-right': '200px' }}>
                  <div className='card-body'>
                    <div className='row'>
                      {/* {JSON.stringify(prescriptionData)} */}
                      <div className='col-md-5'>Doctor : {prescriptionData?.doctor?.full_name}</div>
                      <div className='col-md-2'></div>
                      <div className='col-md-5'>Clinic : {prescriptionData?.clinic?.name}</div>
                    </div>
                  </div>
              </div>
          }

          <div className='card mt-3' style={{ 'margin-left': '50px', 'margin-right': '200px' }}>
            <div className='card-body'>
              <div className='d-flex flex-row gap-4 justify-content-between align-items-center'>
                <h5 className='card-title pt-2 pb-2'>{userDetails?.name}</h5>
                <div className='d-flex align-items-center'>
                {selectedDoctor && selectedClinic && !pid && (
                  <Button
                    appearance="ghost"
                    style={{ backgroundColor: '#2e7d32', color: '#fff', marginRight: '10px' }}
                    className='btn btn-sm text-white'
                    size="sm"
                    onClick={openUploadModal}
                  >
                    Upload Audio
                  </Button>
                )}
                {selectedDepartment && !pid && (
                  <div class='dropdown'>
                    {pafData ?
                      <Button
                      appearance="ghost"
                      style={{"background-color":"#3287eb"}}
                      className='btn btn-sm btn-success text-white'
                      size="sm"
                      onClick={() => editPaf(pafData,id)}
                    >
                      PAF Details
                    </Button>
                    : null}
                    
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <button className='bg-white' type='button' data-bs-toggle='dropdown' aria-expanded='false'>
                      <Menu />
                    </button>
                    <ul class='dropdown-menu'>
                      <li>
                        <p className='dropdown-item' style={{ cursor: 'pointer' }} onClick={() => setOpenNoPrescriptionModal(true)}>
                          No Prescription
                        </p>
                      </li>
                    </ul>
                  </div>
                )}
                </div>
              </div>
              <div className='row'>
                <div className='col-md-4'>Patient id : {userDetails?.id}</div>
                <div className='col-md-4'>Age : {userDetails?.age}</div>
                <div className='col-md-4'>Gender: {userDetails?.gender}</div>
              </div>
            </div>
          </div>
          {/* <InformationViewCard cardData={profileCardData} columns={2} /> */}
          {/* <InformationViewCard cardData={OPDCardData} /> */}

          {selectedDepartment ? renderPage() : null}
          <Modal backdrop='static' size='lg' open={pdfModal} onClose={closeModalPdf}>
            <Modal.Header>
              <Modal.Title>Prescription View</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <iframe src={pdfUrl + '#toolbar=0'} onContextMenu='return false;' width={'100%'} height={window.innerHeight} />
            </Modal.Body>
            <Modal.Footer className='mt-4'>
              <span style={{ float: 'left' }}>
                <CoreButton
                  onClick={() => {
                    setPdfModule(!pdfModal);
                    navigate(`/patient/${id}/prescriptions/${printId}/edit`, { state: { id: printId } });
                  }}
                  title='Back to editing Prescription'
                  customClass='btn btn-md newCoreBtn'
                  core_remove={1}
                />
                {/* <Button 
                    onClick={() => {
                      setPdfModule(!pdfModal);
                      navigate(`/patient/${id}/prescriptions/${printId}/edit`, { state: { id: printId } });
                    }}
                     appearance='defualt'>
                      Back to editing Prescription
                    </Button> */}
              </span>

              <Button onClick={handlePublishAndPrint} appearance='primary'>
                Publish
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal backdrop='static' size='sm' open={openNoPrescriptionModal} onClose={() => setOpenNoPrescriptionModal(false)}>
            <Modal.Header>
              <Modal.Title className='text-center'>
                <TriangleAlert style={{ height: '40px', width: '40px' }} />
                <br />
                <p className='mt-2'>Are you sure there will be no prescription for this patient?</p>
              </Modal.Title>
            </Modal.Header>
            <Modal.Footer className='mt-4'>
              <Button onClick={() => setOpenNoPrescriptionModal(false)} style={{ width: '80px' }} appearance='primary' color='red'>
                No
              </Button>

              <Button onClick={createNoPrescription} style={{ width: '80px' }} appearance='primary'>
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal backdrop='static' size='xs' open={uploadModalOpen} onClose={closeUploadModal}>
            <Modal.Header>
              <Modal.Title>Upload Audio Recording</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input
                ref={uploadInputRef}
                type='file'
                accept='audio/*'
                onChange={handleUploadFileChange}
                style={{ display: 'none' }}
              />

              <div
                onClick={() => uploadInputRef.current?.click()}
                onDragOver={(e) => {
                  e.preventDefault();
                  setIsDragOver(true);
                }}
                onDragLeave={() => setIsDragOver(false)}
                onDrop={handleUploadDrop}
                style={{
                  border: `2px dashed ${isDragOver ? '#0d47a1' : '#c9d4e3'}`,
                  borderRadius: '14px',
                  padding: '28px 16px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  background: isDragOver ? '#eaf1fc' : '#f8fafd',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                {!uploadedFile ? (
                  <>
                    <UploadCloud size={38} color='#0d47a1' style={{ marginBottom: '10px' }} />
                    <p style={{ margin: 0, fontWeight: 600, color: '#0d47a1' }}>Click to upload or drag & drop</p>
                    <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#8a96a3' }}>MP3, WAV, WEBM, M4A supported</p>
                  </>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', textAlign: 'left' }}>
                    <div
                      style={{
                        background: '#0d47a1',
                        borderRadius: '50%',
                        width: '42px',
                        height: '42px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Music size={20} color='#fff' />
                    </div>
                    <div style={{ flex: 1, overflow: 'hidden' }}>
                      <p style={{ margin: 0, fontWeight: 600, color: '#1a1a1a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {uploadedFile.name}
                      </p>
                      <p style={{ margin: 0, fontSize: '12px', color: '#8a96a3' }}>{formatFileSize(uploadedFile.size)}</p>
                    </div>
                  </div>
                )}
              </div>

              {uploadedFileUrl && (
                <>
                  <audio
                    ref={uploadAudioRef}
                    src={uploadedFileUrl}
                    onPlay={() => setIsAudioPlaying(true)}
                    onPause={() => setIsAudioPlaying(false)}
                    onEnded={() => setIsAudioPlaying(false)}
                    style={{ display: 'none' }}
                  />
                  <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                    <Button
                      onClick={toggleAudioPlayback}
                      appearance='ghost'
                      style={{
                        flex: 1,
                        borderColor: '#0d47a1',
                        color: '#0d47a1',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                      }}
                    >
                      {isAudioPlaying ? <Pause size={16} /> : <Play size={16} />}
                      {isAudioPlaying ? 'Pause Audio' : 'Play Audio'}
                    </Button>
                    <Button
                      onClick={removeUploadedFile}
                      appearance='ghost'
                      style={{
                        flex: 1,
                        borderColor: '#d32f2f',
                        color: '#d32f2f',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                      }}
                    >
                      <Trash2 size={16} />
                      Remove Audio
                    </Button>
                  </div>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={closeUploadModal} appearance='subtle'>
                Cancel
              </Button>
              <Button
                onClick={submitUploadedAudio}
                appearance='primary'
                style={{ backgroundColor: '#0d47a1', borderColor: '#0d47a1' }}
              >
                Save & Process
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  };

  return (
    <div className='wrapper'>
      {showPatient()}
      <Loader show={isLoading} />
    </div>
  );
}

export default AddPrescription;
